import Vue from 'vue';

export const supppliersService = {
  async retrieveSupplierDetails(referenceNumber) {
    return Vue.axios.get(`/suppliers/${referenceNumber}`).then(response => response.data);
  },

  async saveSupplier(supplierData, action) {
    let actionUrl = supplierData.reference_number
      ? `/suppliers/${supplierData.reference_number}?action=${action}`
      : `/suppliers/create?action=${action}`;
    return Vue.axios.post(actionUrl, { ...supplierData }).then(response => response.data);
  },

  async retrieveSupplierContractors(referenceNumber, sortOrder) {
    return Vue.axios
      .get(`/suppliers/${referenceNumber}/contractors`, {
        params: {
          ...sortOrder
        }
      })
      .then(response => response.data);
  },
  async retrieveSupplierContacts(referenceNumber, sortOrder) {
    return Vue.axios
      .get(`/suppliers/${referenceNumber}/contacts`, {
        params: {
          ...sortOrder
        }
      })
      .then(response => response.data);
  }
};
